import axios from "axios";
import Config from "src/config";

const v2_actionChatInternoDeletarMsg = (id) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chat-internal/${id}/deletar`
    });
};
export default v2_actionChatInternoDeletarMsg;
